<template>
    <Dropdown :imageUrl="require('../../assets/img/icon_time.svg')" :value="value" @input="$emit('input', $event)">        
        <option v-for="(time, index) in getTimes()" :key="index">
            {{time | moment("h:mma")}}
        </option>
    </Dropdown>
</template>

<script>
import Dropdown from '@/components/controls/Dropdown.vue';
import * as moment from 'moment';

export default {
    components: {
        Dropdown
    },
    props: {
        value: { type: String }
    },
    methods: {
        getTimes() {
            var times = [];

            for (var hours = 6; hours < 24; hours++) {
                for (var minutes = 0; minutes < 60; minutes += 15) {
                    times.push(moment({ hours, minutes }));
                }
            }

            return times;
        }
    }
};
</script>
